import { Grid, Typography, Box } from '@mui/material';
import MissingFiles from '@/components/_common/Draw/MissingFiles';

type NoInventoryV2Props = {
  type: string;
};

const NoInventoryV2 = ({ type }: NoInventoryV2Props) => {
  return (
    <Grid container flexDirection="column" alignItems="center" justifyContent="center" sx={{ p: 4, pt: 6, pb: 6 }}>
      <MissingFiles style={{ maxHeight: 200, width: '100%' }} />
      <Typography variant="h6" sx={{ mt: 5 }}>
        No inventory found for
        <Box sx={{ display: 'inline', ml: '0.5rem', color: type === 'version' ? 'tertiary.main' : 'primary.main' }}>{type}</Box>.
      </Typography>
    </Grid>
  );
};

export default NoInventoryV2;
